export default __webpack_public_path__ + "static/media/guide-12.b8dccddc.png";